import { Effect, Option, Stream } from 'effect';
import type { Layer } from 'effect';
import * as Atom from 'effect/unstable/reactivity/Atom';

import { Announcements, AnnouncementReadiness } from '../../service/announcements/Announcements';
import type {
  AnnouncementGroup,
  AnnouncementSnapshot,
} from '../../service/announcements/Announcements';
import type { Announcement } from '../../service/announcements/Announcement';

export const initialAnnouncementSnapshot: AnnouncementSnapshot = {
  readiness: AnnouncementReadiness.Loading(),
  banner: Option.none(),
  base: Option.none(),
};

export const makeAnnouncementAtoms = (layer: Layer.Layer<Announcements>) => {
  const runtime = Atom.runtime(layer);
  return {
    snapshot: runtime
      .atom(Stream.unwrap(Effect.map(Announcements, (owner) => owner.changes)))
      .pipe(Atom.withServerValueInitial, Atom.keepAlive),
    setMessages: runtime.fn(
      ({
        group,
        messages,
      }: {
        readonly group: AnnouncementGroup;
        readonly messages: readonly Announcement[];
      }) => Effect.flatMap(Announcements, (owner) => owner.setMessages(group, messages)),
      { concurrent: true }
    ),
    dismiss: runtime.fn(
      (id: string) => Effect.flatMap(Announcements, (owner) => owner.dismiss(id)),
      { concurrent: true }
    ),
  };
};

export type AnnouncementAtoms = ReturnType<typeof makeAnnouncementAtoms>;
